import { useEffect, useRef } from "react";

function AudioComponent({ track }) {
  const audioRef = useRef(null);


  useEffect(() => {
    if (track && audioRef.current) {
      track.attach(audioRef.current);
    }

    return () => {
      if (track && audioRef.current) {
        track.detach(audioRef.current);
      }
    };
  }, [track]);

  if (!track) return null;

  return <audio ref={audioRef} /* id={track.sid} */ muted={track.isMuted} autoPlay/>;
}

export default AudioComponent;
